export const ORDER_STATUS_OPTIONS = [
  { value: "pending", label: "Ожидает", color: "#ca8a04" },
  { value: "confirmed", label: "Подтвержден", color: "#16a34a" },
  { value: "in_progress", label: "В процессе", color: "#4f46e5" },
  { value: "completed", label: "Завершен", color: "#16a34a" },
  {
    value: "canceled",
    label: "Отменен",
    color: "var(--color-danger)",
  },
  {
    value: "failed",
    label: "Не удалось выполнить",
    color: "var(--color-danger)",
  },
];

export function orderStatusLabel(status) {
  return orderStatusOption(status)?.label || status || "Без статуса";
}

export function orderStatusColor(status) {
  return orderStatusOption(status)?.color || "#ca8a04";
}

export function orderStatusBorderColor(status) {
  return `5px solid ${orderStatusOption(status)?.color || "#6b7280"}`;
}

export function orderStatusSelectOptions() {
  return ORDER_STATUS_OPTIONS.map((option) => ({ ...option }));
}

function orderStatusOption(status) {
  return ORDER_STATUS_OPTIONS.find((option) => option.value === status);
}
